export default "__VITE_ASSET__a1ca7590__"